import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/docs/docs/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Swagger = makeShortcode("Swagger");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "shared-mobility-api"
    }}>{`Shared mobility API`}</h1>
    <h2 {...{
      "id": "api-swagger-doc"
    }}>{`API Swagger Doc`}</h2>
    <p><a parentName="p" {...{
        "href": "https://petstore.swagger.io/?url=https://api.dev.entur.io/api-docs/shared-mobility"
      }}>{`See the API reference on the Swagger Petstore`}</a></p>
    <Swagger url="https://api.dev.entur.io/api-docs/shared-mobility" baseUrl="https://api.dev.entur.io/shared-mobility/v1" mdxType="Swagger" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      